const servers = {
    dev: "https://hydropro-website-backend-dev.herokuapp.com",
    prod: "https://hydropro-website-backend-2c196d291e0d.herokuapp.com"
};

// export const API_URL = process.env.REACT_APP_API_URL || servers.dev
export const API_URL = servers.prod